import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { appVariantOverrides } from './appVariantOverrides';

export function cn(...inputs: ClassValue[]) {
  const merged = twMerge(clsx(...inputs));

  // Apply app-specific variant overrides
  let result = merged;
  for (const { pattern, append } of appVariantOverrides) {
    if (pattern.test(merged)) {
      result = twMerge(result, append);
    }
  }

  return result;
}
